import { Grid } from "@material-ui/core";
import {
  Autocomplete,
  TextField,
  Chip,
  ButtonGroup,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import RegularButton from "components/CustomButtons/Button";
import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { customersTypeSearch } from "helpers/dictionary";
import { PERMISSIONS } from "router/permissions";
import RestoreIcon from "@material-ui/icons/Restore";
import { cleanCustomers } from "redux/actions/customers/customersAction";
import { useDispatch } from "react-redux";
import { blue, orange } from "@mui/material/colors";

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 8,
};
const styleButton = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const CustomerSearchInput = ({ values }) => {
  const {
    searchCustomers,
    handleInputOnChange,
    handleSearch,
    handleNewValues,
    rules,
    searchType,
    setOpenAvailable,
    isLoadingComp,
  } = values;
  const hasRule = rules.includes(PERMISSIONS.CUSTOMERS_WHOLESALER_FIND);
  const dispatch = useDispatch();

  const theme = useTheme();
  const isTabletOrSmaller = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={3}></Grid>
      <Grid item xs={12} md={3}>
        <Autocomplete
          id="search-customer"
          options={
            hasRule
              ? customersTypeSearch
              : customersTypeSearch.filter((cs) => cs.value !== "wholesalers")
          }
          value={searchType}
          getOptionLabel={(option) => option?.label || ""}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                label={option.label}
                {...getTagProps({ index })}
                style={{
                  borderRadius: 4,
                }}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Tipo de Búsqueda"
              variant="outlined"
              size="small"
            />
          )}
          fullWidth
          onChange={(_, v) => handleNewValues({ searchType: v })}
          noOptionsText="Cuentas no encontradas"
          disabled={isLoadingComp?.loadingCustomers}
        />
      </Grid>
      <Grid item xs={12} md={5} style={style}>
        <TextField
          name="searchCustomers"
          label="Buscar"
          value={searchCustomers}
          onChange={handleInputOnChange}
          variant="outlined"
          size="small"
          fullWidth
          InputProps={{
            endAdornment: (
              <ButtonGroup>
                <RegularButton
                  type="submit"
                  justIcon
                  round
                  color="transparent"
                  size="sm"
                  tooltip="Buscar cliente"
                  onClick={(e) => handleSearch(e)}
                  loading={isLoadingComp?.loadingCustomers}
                  disabled={!searchType ? true : false}
                >
                  <SearchIcon style={{ marginBottom: 0, color: blue[500] }} />
                </RegularButton>
                <RegularButton
                  justIcon
                  round
                  color="transparent"
                  size="sm"
                  onClick={() => dispatch(cleanCustomers())}
                  disabled={isLoadingComp?.loadingCustomers}
                >
                  <RestoreIcon
                    style={{ marginBottom: 0, color: orange[500] }}
                  />
                </RegularButton>
                <RegularButton
                  justIcon
                  round
                  color="transparent"
                  size="sm"
                  onClick={() =>
                    handleNewValues({
                      searchCustomers: "",
                    })
                  }
                >
                  <CloseIcon />
                </RegularButton>
              </ButtonGroup>
            ),
          }}
          disabled={isLoadingComp?.loadingCustomers}
        />
      </Grid>
      <Grid item xs={12} md={1} style={styleButton}>
        <RegularButton
          justIcon={isTabletOrSmaller}
          round={isTabletOrSmaller}
          color="info"
          size="sm"
          tooltip="Nuevo Cliente"
          onClick={setOpenAvailable}
          loading={isLoadingComp?.loadingCustomers}
          fullWidth={!isTabletOrSmaller}
        >
          {!isTabletOrSmaller ? (
            "Registrar cuenta"
          ) : (
            <PersonAddIcon style={{ margin: 0 }} />
          )}
        </RegularButton>
      </Grid>
    </Grid>
  );
};
